<div class="container-main">
  <div class="container">
    <div class="row"> 
      <div class="col-12 form-group">
        <span class="title-line">Cursos Android ANT</span>
      </div>
      <div class="col-12 col-sm-6">
        <div>
          <p class="subtitle-line">Java</p>
        </div>
        <div class="container-line" *ngFor="let course of courses">
          <div class="card" style="width: 100%;" *ngIf="course.languages.java == true && !course.free">
            <img class="card-img-top" [src]="course.photoUrl">
            <div class="card-body">
              <h5 class="card-title">{{ course.title }}</h5>
              <p class="card-text">{{ course.subtitle }}</p>
              <a class="link-card" (click)="goToPage(course)">Más Información...</a>
            </div>
            <div class="card-footer">
              <button class="button-card" (click)="goToCourse(course)">Obtener curso</button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 border-left">
        <div>
          <p class="subtitle-line">Kotlin</p>
        </div>
        <div class="container-line" *ngFor="let course of courses">
          <div class="card" style="width: 100%;" *ngIf="course.languages.kotlin == true && !course.free">
            <img class="card-img-top" [src]="course.photoUrl">
            <div class="card-body">
              <h5 class="card-title">{{ course.title }}</h5>
              <p class="card-text">{{ course.subtitle }}</p>
              <a class="link-card" (click)="goToPage(course)">Más Información...</a>
            </div>
            <div class="card-footer">
              <button class="button-card" (click)="goToCourse(course)">Obtener curso</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>